import type { MessagingGetChatRoomById200BasicInfoAllOfTwoType } from './messagingGetChatRoomById200BasicInfoAllOfTwoType';

/**
 * 채팅방 기본 정보
 */
export type MessagingGetChatRoomById200BasicInfoAllOfTwo = {
  name?: string;
  type?: MessagingGetChatRoomById200BasicInfoAllOfTwoType;
};
